var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.667 1.667a.792.792 0 00-.792.791v11.084a.792.792 0 00.792.791h12.666a.792.792 0 00.792-.791V4.833a.792.792 0 00-.792-.791H8.208a.792.792 0 01-.658-.353L6.2 1.667H2.667zM.987.779a2.375 2.375 0 011.68-.696h3.958c.265 0 .512.133.659.353l1.348 2.022h6.701a2.375 2.375 0 012.375 2.375v8.709a2.375 2.375 0 01-2.375 2.375H2.667a2.375 2.375 0 01-2.375-2.375V2.458c0-.63.25-1.234.695-1.68z",
    fill: "#000"
  })));
}
export default SvgFolderIcEmpty;